import Vue from 'vue'
import VueRouter from 'vue-router'
import { getSeoTitle } from '@/api'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    meta: { title: '首页', bg: false },
    component: () => import('../views/index.vue'),
  },
  {
    path: '/about',
    name: 'about',
    meta: { title: '关于我们', bg: true },
    component: () => import('../views/about.vue'),
  },
  {
    path: '/applicate',
    name: 'applicate',
    meta: { title: '业务模块', bg: true },
    component: () => import('../views/applicate.vue'),
  },
  {
    path: '/product',
    name: 'product',
    meta: { title: '产品中心', bg: true },
    component: () => import('../views/product.vue'),
  },
  {
    path: '/solve',
    name: 'solve',
    meta: { title: '解决方案', bg: true },
    component: () => import('../views/solve.vue'),
  },
  {
    path: '/news',
    name: 'news',
    meta: { title: '新闻咨讯', bg: true },
    component: () => import('../views/news.vue'),
    children: [
      {
        path: 'newsInfo',
        name: 'newsInfo',
        meta: { title: '详情', bg: true },
        component: () => import('../views/newsInfo.vue'),
      },
    ]
  },
  {
    path: '/case',
    name: 'case',
    meta: { title: '精彩案例', bg: true },
    component: () => import('../views/case.vue'),
  },
  {
    path: '/join',
    name: 'join',
    meta: { title: '加入我们', bg: true },
    component: () => import('../views/join.vue'),
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ selector: to.hash, behavior: 'smooth' })
        }, 500)
      })
      // return { selector: to.hash, behavior: 'smooth' }
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 };
    }
  },
})
let title = ''
router.beforeEach((to, from, next) => {
  if (title) {
    document.title = to.meta.title + '-' + title;
  } else {
    getSeoTitle().then(res => {
      if (res.code == 0&&res.data) {
        title = res.data;
        document.title = to.meta.title + '-' + title;
      }else{
        document.title = to.meta.title;
      }
    })
  }
  // if (to.meta.title) {
  //   // if (to.meta.content) {
  //   //   document.getElementsByName("description")[0].content = to.meta.content;
  //   // }
  // } else {
  //   document.title = '网站名称';
  // }
  next();
});
export default router